<template>
  <div>

    <el-dialog
        :title="setName"  :visible.sync="showSet" width="40%" :before-close="handleClose">
      <div>{{lan == 'ch'?'所有时间以北京时间为准':'Subject to Beijing Time'}} </div>
<div style="margin-bottom: 20px;" v-for="(v,i) in exh_days_json" :key="i">
  <div v-if="lan == 'ch'">{{exh_days_json[i].days}}</div>

        <el-time-select

            :placeholder="language.StartingTime"
            v-model="exh_days_json[i].start_time"
            
            :picker-options="{
              start: '09:00',
              step: '00:30',
              end: '22:00'
            }"
            @change="setday(i)"
        >
        </el-time-select>
        <el-time-select
            style="margin-left: 20px;"
            v-model="exh_days_json[i].end_time"

            :disabled="exh_days_json[i].allday == 1?true:false"
            :picker-options="{
             start: '09:30',
              step: '00:30',
              end: '22:30',
              minTime: exh_days_json[i].startTime
            }"
          @change="setday(i)"
    >
        </el-time-select>
  <el-checkbox v-model="exh_days_json[i].allday"  style="margin-left: 20px;">{{language.FullDay}}</el-checkbox>
</div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{language.cancel}}</el-button>
      <el-button type="primary" @click="handleSubmit">{{language.confirm}}</el-button>
    </span>
    </el-dialog>


  </div>
</template>

<script>
import {subject_set} from "@/api/forum";
export default {
  props:['showSet','setName','exh_days_json','broadcast_id','exhibition_id','language','lan'],
  data() {
    return {
      dialogVisible: false,
      Time: []
    }
  },
  methods: {
    handleClose(done) {
      // this.$confirm('确认关闭？')
      //     .then(_ => {
      //       //done();
      //       this.$emit('toogleSet',false);
      //     })
      //     .catch(_ => {});
      this.$emit('toogleSet',false);
    },
    handleChange(value) {
      console.log(value);
    },
    handleSubmit(){
      this.message = this.lan == 'ch' ? '是否确认设置?' : 'Confirm settings ?';
   this.$confirm(this.message)
          .then(_ => {
             
              let params = {
                "token":this.$store.state.user.token,
                "broadcast_id":this.broadcast_id,
                "exh_days_json":this.exh_days_json,
                "exhibition_id":this.exhibition_id
              }

              subject_set(params).then((data)=>{
                  this.$message.success(this.lan == 'ch' ? '设置成功' : 'Setup succeeded');
                  this.$emit('toogleSet',false);
              });
            
          })
          .catch(_ => {});
   
    },
    setday(i){
      // this.exh_days_json[i].inday = 1;
      // if(this.exh_days_json[i].startTime == null && this.exh_days_json[i].endTime == null){
      //   this.exh_days_json[i].inday = 0;
      // }
    }
  }
};
</script>

<style scoped>

</style>